import { render, staticRenderFns } from "./EditManagementCompany.vue?vue&type=template&id=58bc13c7"
import script from "./EditManagementCompany.vue?vue&type=script&lang=js"
export * from "./EditManagementCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports